import React from "react";
import { Link } from "react-router-dom";

function isInternal(href) {
  return href.startsWith("/");
}

export function ButtonLink({ href, children, variant = "primary", className = "", ariaLabel }) {
  const classes = `button button-${variant} ${className}`.trim();

  if (isInternal(href)) {
    return (
      <Link className={classes} to={href} aria-label={ariaLabel} data-testid="button-link">
        {children}
      </Link>
    );
  }

  return (
    <a className={classes} href={href} aria-label={ariaLabel} data-testid="button-link">
      {children}
    </a>
  );
}

export function DisabledButton({ children }) {
  return (
    <span className="button button-disabled" aria-disabled="true" data-testid="disabled-button">
      {children}
    </span>
  );
}
